/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Valid_Last_DateInputs */

const fr_validation_valid_last_date = /** @type {(inputs: Validation_Valid_Last_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez une dernière date admissible valide.`)
};

const en_validation_valid_last_date = /** @type {(inputs: Validation_Valid_Last_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a valid last eligible date.`)
};

/**
* | output |
* | --- |
* | "Enter a valid last eligible date." |
*
* @param {Validation_Valid_Last_DateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_valid_last_date = /** @type {((inputs?: Validation_Valid_Last_DateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Valid_Last_DateInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_valid_last_date(inputs)
	return fr_validation_valid_last_date(inputs)
});